// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__24RsV","head":"index_head__tEQZd","head_crumbs":"index_head_crumbs__2j3gG","head_line":"index_head_line__3CFbM"};